import useTranslation from '@app/hooks/use-translation';

import { OptionItem } from '@app/components/ui/select/select.type';

import { AliasSettingsObj } from '@app/interfaces/settings.type';

import { FilterOptionsListAndRules } from '../../qm-appeal/blocks/appeal-filter/types';

export const useGetMonitoringFilterData = ({
  operators,
  controllers,
  aliases,
}: {
  operators: OptionItem[];
  controllers: OptionItem[];
  aliases?: AliasSettingsObj[] | undefined;
}) => {
  const { t } = useTranslation('pages.qmManage.statistic');
  const additionalOptions =
    aliases
      ?.filter((item) => !item.forbidden_rules)
      ?.map<FilterOptionsListAndRules>((alias) => ({
        index: alias.alias_id,
        title: alias.name,
        value_type: alias.type_value === 'num' ? 'number' : 'string',
        conditions: alias.type_value === 'str' ? 'equal' : 'all',
        // type_meta: alias.type_meta,
        // type_value: alias.type_value,
      })) || [];
  const monitoringFilterKeys: FilterOptionsListAndRules[] = [
    {
      index: 'score',
      title: t('filter.score'),
      conditions: 'all',
      singleNestedField: true,
      field_type: 'input',
    },
    {
      index: 'controller',
      title: t('filter.controller'),
      conditions: 'equal',
      field_type: 'select',
      select: { options: controllers },
      hide: !controllers.length,
    },
    {
      index: 'operator',
      title: t('filter.operator'),
      conditions: 'equal',
      field_type: 'select',
      select: { options: operators },
      hide: !operators.length,
    },
  ];
  return { monitoringFilterKeys, additionalOptions };
};
